import { BUSCAR_RESERVAS_REPASSE } from '../../actions/types'

export default function reducerReservasRepasse(state = [], action) {
    switch (action.type) {
        case BUSCAR_RESERVAS_REPASSE: {
            return action.payload.data;
        }
        
        default: {
            return state
        }
    }
}
